import { createStore, applyMiddleware, compose } from 'redux'
import createSagaMiddleware, { END } from 'redux-saga'
import ReduxDebug from 'redux-debug'
import debug from 'debug'
import { routerMiddleware } from 'connected-react-router'

import createRootReducer from '../reducers'

export default function configureStore(history = null, initialState) {
  const sagaMiddleware = createSagaMiddleware()
  const reduxRouterMiddleware = routerMiddleware(history)
  const store = createStore(
    createRootReducer(history),
    initialState,
    compose(
      applyMiddleware(sagaMiddleware, ReduxDebug(debug('redux')), reduxRouterMiddleware),
      typeof window === 'object' && typeof window.devToolsExtension !== 'undefined'
        ? window.devToolsExtension()
        : (callback) => callback,
    ),
  )

  if (process.env.NODE_ENV === 'development' && module.hot) {
    module.hot.accept('../reducers', () => {
      // eslint-disable-next-line global-require
      const nextCreateRouteReducer = require('../reducers').default
      store.replaceReducer(nextCreateRouteReducer(history))
    })
  }

  store.runSaga = sagaMiddleware.run
  store.close = () => store.dispatch(END)
  return store
}
